import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"

export const state = () => ({
  lang: process.env.VUE_APP_I18N_LOCALE,
  isContestClosed: false,
  appDomain: null,
  destinations: [],
  selectedDestination: null,
  sentInvitations: {},
  user: {},
  utms: {
    utm_source: "TuangoWinYourGetawayContest_2023",
    utm_campaign: "WinYourGetawayContest_2023",
    utm_medium: "ContestPage",
    utm_content: null,
    utm_term: null
  }
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
